/* istanbul ignore file */
import React, { ReactNode } from 'react';
import { ProcessDefinitionBreadcrumbs } from 'domain/gpo/cockpit/definition';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import { Breadcrumbs } from '@mui/material';

interface Props {
  children?: ReactNode | undefined | null;
}

const ProcessInstanceBreadcrumbs = ({ children }: Props) => {
  const id = useProcessInstanceId();

  return (
    <ProcessDefinitionBreadcrumbs source="processKey">
      <Breadcrumbs>
        <SingleBreadcrumbItem entity={id} />
        {children}
      </Breadcrumbs>
    </ProcessDefinitionBreadcrumbs>
  );
};

export default ProcessInstanceBreadcrumbs;
